export const ACTIVITY_FEED_AS_OF_PREFIX = 'Since';
